import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';

const DeleteActionCell = (props: GridCellProps) => {
  const { setBudgetPeriods } = useViewBudgetPeriod();
  const { dataItem, dataIndex } = props;
  const handleDeleteCell = useCallback(() => {
    setBudgetPeriods((prev) => {
      const items = [...prev];
      items?.splice(dataIndex, 1);
      return items;
    });
  }, [dataIndex, setBudgetPeriods]);

  return (
    <GridCellBase {...props}>
      {dataItem.isDeletable ? (
        <Button onClick={handleDeleteCell} color="error">
          Delete
        </Button>
      ) : undefined}
    </GridCellBase>
  );
};

export default DeleteActionCell;
